import type { SearchResultItemData } from '@beat-venues/common-types';
import { venueConfigUtil } from '@beat-venues/venue-config';
import { useTranslation } from 'next-i18next';
import { tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';
import { ButtonOrLink } from '../button-or-link';
import { Heading } from '../heading';
import { Paragraph } from '../paragraph';
import { Text } from '../text';

export interface SearchResultItemProps
    extends CommonProps,
        Omit<SearchResultItemData, 'id'> {}

const SearcResultItemStyles = tv({
    slots: {
        root: 'search-list-item mb-11 block click-area',
        heading: 'mb-0',
        paragraph: 'mb-1.5 line-clamp-2',
        date: 'mb-3 block',
        venueList: 'mr-1',
        readMore: 'underline',
    },
});

export const SearchResultItem = ({
    type,
    title,
    cmsContent,
    date,
    url,
    className,
    venueCode,
    testId = 'search-result-item',
    ...props
}: SearchResultItemProps): JSX.Element => {
    const { t } = useTranslation('global');

    const {
        root,
        heading,
        paragraph,
        date: dateStyle,
        venueList,
        readMore,
    } = SearcResultItemStyles();

    const excludeVenueCodes = ['BT', 'PA'];

    const venueNames = venueCode
        ?.filter((venue) => !excludeVenueCodes.includes(venue))

        .map((venue) => {
            if (venue === 'AS') {
                return t(
                    `venues.${venueConfigUtil.getVenueIdByCode('AD')}.name`
                );
            } else {
                return t(
                    `venues.${venueConfigUtil.getVenueIdByCode(venue)}.name`
                );
            }
        });
    const venueString = venueNames
        .filter((value, index) => venueNames.indexOf(value) === index)
        .join(' • ');

    return (
        <li className={root({ className })} {...props} data-testid={testId}>
            <Text>{t(`type.${type}`, { ns: 'search' })}</Text>
            <ButtonOrLink className="click-area-link" href={url}>
                <Heading
                    className={heading()}
                    // @ts-expect-error Todo: will solve this later
                    dangerouslySetInnerHTML={{ __html: title }}
                    size="h4"
                ></Heading>
            </ButtonOrLink>
            {cmsContent && (
                <Paragraph
                    className={paragraph()}
                    // @ts-expect-error Todo: will solve this later
                    dangerouslySetInnerHTML={{ __html: cmsContent }}
                ></Paragraph>
            )}
            {date && <Text className={dateStyle()}>{date}</Text>}
            <div>
                <Text className={venueList()}>{venueString}</Text>
            </div>
            <Text className={readMore()} size="lg">
                {t('readMore', { ns: 'search' })}
            </Text>
        </li>
    );
};
